export enum EnumPricingItemType {
    CONSUMABLE = 'CONSUMABLE',
    DEVICE_CONSUMABLE = 'DEVICE_CONSUMABLE',
    DEVICE = 'DEVICE',
    PACK = 'PACK',
    DEVICE_CONSUMABLE_WITH_SUPP = 'DEVICE_CONSUMABLE_WITH_SUPP',
    OPTION = 'OPTION',
}
